import "bootstrap/dist/css/bootstrap.min.css";
// import "./bootstrap.min.css";
import "../styles/ld-original.css";
import "../styles/style.css";
import "../styles/add-style.css";

import { Avatar, Button, Link, Box, IconButton } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import getInfo from "../functions/getInfo";
import { DataContext } from "../context/DataContext";
import registFromUrl from "../functions/registFromUrl";
import { animateScroll as scroller } from "react-scroll";
import CloseIcon from "@mui/icons-material/Close";
import getAiSdrConfig, {
  defaultAiSdrConfig,
} from "../functions/getAiSdrConfig";
import AiSdrChat from "../components/aisdr/AiSdrChat";
import Launcher from "../components/aisdr/Launcher";
import ExpandedVideo from "../components/aisdr/ExpandedVideo";
import BookingPanel from "../components/booking/BookingPanel";

// 親ページ(設置タグ)へ通知する iframe のサイズ。
// 新しいタグはこの値を使い、旧タグは width/height を無視して従来値(350x400 / 120x120)で動く。
const PANEL_SIZE = { width: 350, height: 400 };
const AISDR_PANEL_SIZE = { width: 380, height: 600 };
const MINIMIZED_SIZE = { width: 120, height: 120 };

// ランチャーや拡大プレイヤーは中身で高さが変わる（担当者の吹き出し・動画の縦横・
// CTAの有無）ので、サイズは固定値ではなく実際に描画された要素から測って親へ渡す。
// 影やリップルが切れないぶんの余白。
const SIZE_MARGIN = 40;

// lead-dynamics widget.js の pickActiveVideoUrl() 相当。
// 選ばれている枠の URL だけを返す（未選択なら出さない）。
const pickActiveVideoUrl = (config) => {
  if (config.videoActiveVariant === "desktop") return config.videoDesktopUrl;
  if (config.videoActiveVariant === "mobile") return config.videoMobileUrl;
  return null;
};

// ランチャーを畳んでいるか。LD の sessionStorage(aisdr_lmin) と同じ扱いで、
// 明示的に開閉した場合だけその選択をセッション中おぼえる。
const LAUNCHER_MIN_KEY = "aisdr_lmin";
const storedLauncherMin = () => {
  try {
    const value = sessionStorage.getItem(LAUNCHER_MIN_KEY);
    if (value === "1") return true;
    if (value === "0") return false;
  } catch (error) {
    // プライベートブラウズなどで読めない場合は既定値に任せる
  }
  return null;
};

const VISITOR_ID_KEY = "aisdr_visitor_id";
const getVisitorId = () => {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  if (!visitorId) {
    visitorId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `v${Date.now()}${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  return visitorId;
};

function IframePage() {
  // const { setDomain, firstAccount, domain } = useContext(DataContext);
  const { setWhereFrom } = useContext(DataContext);
  const [firstAccount, setFirstAccount] = useState({});
  const [helpMessageOpen, setHelpMessageOpen] = useState(false);
  const [online, setOnline] = useState(false);
  const [haveSubbutton, setHaveSubbutton] = useState(true);

  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(true);

  const [aiSdrConfig, setAiSdrConfig] = useState(defaultAiSdrConfig);
  const [visitorId] = useState(getVisitorId);

  // 日程調整パネル（担当者がオフラインのときの受け皿）
  const [bookingOpen, setBookingOpen] = useState(false);
  // 日程調整の予約リンク。「はじめに表示する担当者」とは限らないので別に持つ
  const [bookingSlug, setBookingSlug] = useState("");

  // 動画設置まわり
  const [videoOpen, setVideoOpen] = useState(false);
  const [videoDismissed, setVideoDismissed] = useState(false);
  // ランチャーを畳んでいるか。null = 未操作（端末幅で決める）
  const [launcherMinChoice, setLauncherMinChoice] = useState(storedLauncherMin);
  const [parentSize, setParentSize] = useState(null);
  // 全画面のCTAから開いたときに、そのまま1通目として送る文言
  const [pendingMessage, setPendingMessage] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 5 * 1000);
  }, []);

  const navigate = useNavigate();
  let params = useParams();
  const [searchParams] = useSearchParams();

  const domain = params.domain;
  let fromUrl = document.referrer;

  // const fromUrl = "https://sukenojo.com/";

  const scrollToTop = () => {
    console.log("clicked");
    scroller.scrollTo("scroll_down", {
      duration: 1000,
      delay: 2000,
      smooth: true,
      offset: -50,
    });
  };

  const handleNextButton = async () => {
    registFromUrl(domain, fromUrl, navigate);
  };

  // 設置タグがローダー版(public/t.js)かどうか。
  // 動画は親ページ側の協力（ビューポート通知・サイズ変更）が要るため新タグでのみ出す。
  const loaderTag = searchParams.get("v") === "2";

  // 「600px以下か」は iframe の幅では判定できないので、親から送られた
  // ビューポート幅を使う。届く前や旧タグでは端末の画面幅で代用する。
  const viewportWidth = parentSize?.width ?? window.screen?.width ?? 1024;
  const viewportHeight = parentSize?.height ?? window.screen?.height ?? 900;
  const isMobileViewport = viewportWidth <= 600;

  // 未操作ならモバイルは畳んだ状態で始める（LD と同じ既定）
  const launcherMin = launcherMinChoice ?? isMobileViewport;
  const changeLauncherMin = (value) => {
    setLauncherMinChoice(value);
    try {
      sessionStorage.setItem(LAUNCHER_MIN_KEY, value ? "1" : "0");
    } catch (error) {
      // 保存できなくても表示自体は続けられる
    }
  };

  const videoUrl = loaderTag ? pickActiveVideoUrl(aiSdrConfig) : null;
  // アスペクトは端末ではなく「選んだ枠」で決まる（LD の pickActiveVideoAspect と同じ）
  const videoVertical = aiSdrConfig.videoActiveVariant === "mobile";
  const showVideo = !!videoUrl && !videoDismissed;

  const handleCloseClick = () => {
    setOpen(false);
    // AI SDR のときは下の useEffect が実寸を測って通知する
    if (!aiSdrConfig.enabled) {
      window.parent.postMessage({ isMinimized: true, ...MINIMIZED_SIZE }, "*");
    }
  };

  const handleExpandClick = () => {
    setVideoOpen(false);
    setOpen(true);
    if (!aiSdrConfig.enabled) {
      window.parent.postMessage({ isMinimized: false, ...PANEL_SIZE }, "*");
    }
  };

  // 拡大プレイヤーはページを覆わず右下に出すので、親に頼むのはサイズ変更だけ
  const openExpandedVideo = () => setVideoOpen(true);
  const closeExpandedVideo = () => setVideoOpen(false);

  // 日程調整はページ全体を使いたいので、親に iframe の拡大を頼む
  const openBooking = () => {
    setVideoOpen(false);
    setBookingOpen(true);
    window.parent.postMessage({ fullscreen: true }, "*");
  };
  const closeBooking = () => {
    setBookingOpen(false);
    window.parent.postMessage({ fullscreen: false }, "*");
  };

  useEffect(() => {
    // ドメイン取得して、isFirstアカウントの情報を取得
    getInfo(
      domain,
      fromUrl,
      setFirstAccount,
      setOnline,
      setHaveSubbutton,
      setBookingSlug
    );
    setWhereFrom(fromUrl);
    // AI SDR 設定。enabled のときだけチャットUIに切り替える
    getAiSdrConfig(domain).then(({ config }) => {
      setAiSdrConfig(config);
      // 表示中の動画があるときは、動画を見せるためにランチャー状態で始める。
      // 動画が無ければ従来どおりパネルを開いた状態。
      if (config.enabled && loaderTag && pickActiveVideoUrl(config)) {
        setOpen(false);
      }
    });
    // eslint-disable-next-line
  }, []);

  // AI SDR のUIはランチャーのように「四角くない」形で出るため、iframe の下地が
  // 白いと設置サイトの背景を四角く塗りつぶしてしまう。有効なときだけ透過にする。
  // （従来のボタンUIは背景ありきの見た目なので触らない）
  useEffect(() => {
    if (!aiSdrConfig.enabled) return undefined;
    const html = document.documentElement;
    const prevHtml = html.style.background;
    const prevBody = document.body.style.background;
    html.style.background = "transparent";
    document.body.style.background = "transparent";
    return () => {
      html.style.background = prevHtml;
      document.body.style.background = prevBody;
    };
  }, [aiSdrConfig.enabled]);

  // 親から送られるビューポートを受け取る（ローダー版タグのみ送ってくる）
  useEffect(() => {
    const onMessage = (event) => {
      const data = event.data || {};
      if (data.type !== "nonapo:viewport") return;
      if (typeof data.width !== "number") return;
      setParentSize({ width: data.width, height: data.height });
    };
    window.addEventListener("message", onMessage);
    // リスナを張ってから要求する。load 時の送信と行き違っても取りこぼさない。
    window.parent.postMessage({ type: "nonapo:ready" }, "*");
    return () => window.removeEventListener("message", onMessage);
  }, []);

  // iframe のサイズ通知。
  // パネルは固定サイズ、ランチャーと拡大プレイヤーは描画結果を実測して渡す。
  useEffect(() => {
    if (!aiSdrConfig.enabled) return undefined;
    // 予約パネル中は親が全画面にしているのでサイズ指示を出さない
    if (bookingOpen) return undefined;

    if (open) {
      window.parent.postMessage(
        { isMinimized: false, ...AISDR_PANEL_SIZE },
        "*"
      );
      return undefined;
    }

    const el = document.querySelector(".aisdr-vp2, .aisdr-lc");
    if (!el) return undefined;

    const post = () => {
      const rect = el.getBoundingClientRect();
      window.parent.postMessage(
        {
          isMinimized: true,
          width: Math.ceil(rect.width) + SIZE_MARGIN,
          height: Math.ceil(rect.height) + SIZE_MARGIN,
        },
        "*"
      );
    };
    post();

    // アバターの画像読み込みや動画のメタデータ確定で高さが変わるため監視する
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(post);
    observer.observe(el);
    return () => observer.disconnect();
  }, [
    aiSdrConfig.enabled,
    open,
    bookingOpen,
    videoOpen,
    launcherMin,
    showVideo,
    isMobileViewport,
    videoVertical,
    viewportHeight,
    online,
    firstAccount?.avatar,
  ]);

  // AI SDR が有効なテナントはチャットUIに差し替える。
  // 無効なら従来どおりボタンのみのUI（既存顧客に影響を出さない）。
  if (aiSdrConfig.enabled) {
    return (
      <div style={{ display: show ? "block" : "none", height: "100vh" }}>
        {open && (
          <AiSdrChat
            config={aiSdrConfig}
            account={firstAccount}
            online={online}
            domain={domain}
            visitorId={visitorId}
            initialMessage={pendingMessage}
            onInitialMessageSent={() => setPendingMessage(null)}
            onMinimize={handleCloseClick}
            onStartMeeting={handleNextButton}
          />
        )}

        {!open && videoOpen && !bookingOpen && videoUrl && (
          <ExpandedVideo
            url={videoUrl}
            vertical={videoVertical}
            themeColor={aiSdrConfig.themeColor}
            online={online}
            mainButtonLabel={firstAccount?.mainButton}
            parentHeight={viewportHeight}
            onClose={closeExpandedVideo}
            onStartMeeting={handleNextButton}
            onOpenChat={handleExpandClick}
          />
        )}

        {bookingOpen && bookingSlug && (
          <BookingPanel slug={bookingSlug} onClose={closeBooking} />
        )}

        {!open && !videoOpen && !bookingOpen && (
          <Launcher
            account={firstAccount}
            online={online}
            canBook={!!bookingSlug}
            themeColor={aiSdrConfig.themeColor}
            minimized={launcherMin}
            videoUrl={showVideo ? videoUrl : null}
            videoMobile={isMobileViewport}
            videoVertical={videoVertical}
            onDismissVideo={() => setVideoDismissed(true)}
            onOpenVideo={openExpandedVideo}
            onOpenChat={handleExpandClick}
            onStartMeeting={handleNextButton}
            onOpenBooking={bookingSlug ? openBooking : handleExpandClick}
            onMinimize={() => changeLauncherMin(true)}
            onRestore={() => changeLauncherMin(false)}
          />
        )}
      </div>
    );
  }

  return (
    <div
      id="wrap"
      style={{
        display: show ? "block" : "none",
      }}
    >
      <main id="content" className="content">
        {/* <section className="cover-blue">
          <div className="container">
            <div className="row"></div>
          </div>
        </section> */}
        {open ? (
          <div className="chat customize-chat" id="p2">
            <div className="chat-title chat-title-customize">
              <h1 style={{ display: "inline" }}>{firstAccount?.username}</h1>
              <br />
              {online ? (
                <>
                  <span className="atn btn--shockwave is-active"></span>
                  <span
                    style={{
                      color: "#181b31",
                      fontSize: "10px",
                      marginRight: "6px",
                    }}
                  >
                    オンライン
                  </span>
                </>
              ) : (
                <>
                  <span className="btn btn_shockwave passive"></span>
                  <span
                    style={{
                      color: "#181b31",
                      fontSize: "10px",
                      marginRight: "6px",
                    }}
                  >
                    オフライン
                  </span>
                </>
              )}

              <h2 style={{ display: "inline" }}>{firstAccount?.company}</h2>
              <Box sx={{ position: "absolute", top: "8px", left: "9px" }}>
                <Avatar
                  sx={{
                    height: "30px",
                    width: "30px",
                  }}
                  src={firstAccount?.avatar}
                />
              </Box>
              <IconButton
                onClick={handleCloseClick}
                sx={{
                  display: "inline-block",
                  width: "24px",
                  height: "24px",
                  padding: "0",
                  float: "right",
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div className="messages">
              <div className="messages-content scroll">
                <div className="message new">
                  <figure className="avatar">
                    <Avatar
                      sx={{ width: "26px", height: "26px" }}
                      src={firstAccount?.avatar}
                    />
                  </figure>
                  何かお困りの事はございませんか？
                </div>
                <div className="message new">
                  <figure className="avatar">
                    <Avatar
                      sx={{ width: "26px", height: "26px" }}
                      src={firstAccount?.avatar}
                    />
                  </figure>
                  今すぐオンライン商談が可能です！
                  <br />
                  <img
                    className="mtg-bg"
                    src={firstAccount?.thumbnail}
                    style={{ maxHeight: "100px", objectFit: "cover" }}
                  />
                  <div
                    className="mtg-btn message-submit btn-gradient-bg"
                    style={{ display: "none" }}
                  >
                    <a href="#">アポなし面談</a>
                  </div>
                </div>
                {helpMessageOpen && (
                  <>
                    <div className="message new">
                      <figure className="avatar">
                        <Avatar
                          sx={{ width: "26px", height: "26px" }}
                          src={firstAccount?.avatar}
                        />
                      </figure>
                      {firstAccount?.subButtonTitle}ですね
                    </div>
                    <div className="message new customize-message">
                      <figure className="avatar">
                        <Avatar
                          sx={{ width: "26px", height: "26px" }}
                          src={firstAccount?.avatar}
                        />
                      </figure>
                      下記からお選びください。
                      <br />
                      <br />
                      <div className="row chat-btns">
                        <div className="col-md-12">
                          {firstAccount?.button?.map((item) => {
                            if (item.title === "") {
                              return <></>;
                            } else {
                              return (
                                <Link
                                  target="_top"
                                  href={item.url}
                                  sx={{ textDecoration: "none" }}
                                >
                                  <Button
                                    key={item.title}
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                      background: "rgb(255 255 255)",
                                      border: "1px solid #4762ff !important",
                                      color: "#4762ff !important",
                                      borderRadius: "15px",
                                      fontSize: "15px",
                                      boxShadow:
                                        "0px 3px 16px 0px rgb(0 0 0 / 12%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%)",
                                      fontWeight: "700",
                                      lineHeight: "0",
                                      height: "33px",
                                      py: 0,
                                      mb: "10px",
                                    }}
                                  >
                                    {item.title}
                                  </Button>
                                </Link>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="message-box">
              <div className="content">
                {/* サブボタンを設定している？サブボタンは任意 */}
                {haveSubbutton === false ? (
                  <div className="row">
                    <div className="col-3"></div>
                    <div
                      className="col-6"
                      style={{
                        paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                        paddingRight: "calc(var(--bs-gutter-x)*.2)",
                      }}
                    >
                      <div className="buttons">
                        <Button
                          onClick={() => {
                            handleNextButton();
                            // navigate(`/${domain}`);
                            // window.location.href = `https://mtg-non-apo.web.app/${domain}`;
                          }}
                          variant="contained"
                          sx={{
                            p: 0,
                            color: "#fff",
                            backgroundColor: "#4762ff",
                            paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                            paddingRight: "calc(var(--bs-gutter-x)*.2)",
                          }}
                          className="button btn-apo-bg circle"
                          disabled={!online}
                        >
                          {firstAccount?.mainButton}
                        </Button>
                      </div>
                    </div>
                    <div className="col-3"></div>
                  </div>
                ) : (
                  <div className="row">
                    <div
                      className="col-6"
                      style={{
                        paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                        paddingRight: "calc(var(--bs-gutter-x)*.2)",
                      }}
                    >
                      <div className="buttons">
                        {/* サブボタンを設定している人の内、複数ボタンを持っている？ */}
                        {firstAccount?.isOneSubButton ? (
                          <>
                            <Link
                              href={firstAccount?.button[0]?.url}
                              target="_top"
                              sx={{ textDecoration: "none" }}
                            >
                              <Button
                                variant="outlined"
                                sx={{
                                  p: 0,
                                  fontSize: "16px",
                                  paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                                  paddingRight: "calc(var(--bs-gutter-x)*.2)",
                                }}
                                className="button btn-now-bg circle message-sub"
                              >
                                {firstAccount?.button[0]?.title}
                              </Button>
                            </Link>
                          </>
                        ) : (
                          <Button
                            onClick={() => {
                              setHelpMessageOpen(true);
                              scrollToTop();
                            }}
                            variant="outlined"
                            sx={{
                              p: 0,
                              fontSize: "16px",
                              paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                              paddingRight: "calc(var(--bs-gutter-x)*.2)",
                            }}
                            className="button btn-now-bg circle message-sub"
                          >
                            {firstAccount?.subButtonTitle}
                          </Button>
                        )}
                      </div>
                    </div>
                    <div
                      className="col-6"
                      style={{
                        paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                        paddingRight: "calc(var(--bs-gutter-x)*.2)",
                      }}
                    >
                      <div className="buttons">
                        <Button
                          onClick={() => {
                            handleNextButton();
                            // navigate(`/${domain}`);
                            // window.location.href = `https://mtg-non-apo.web.app/${domain}`;
                          }}
                          variant="contained"
                          sx={{
                            p: 0,
                            color: "#fff",
                            backgroundColor: "#4762ff",
                            fontSize: "16px",
                            paddingLeft: "calc(var(--bs-gutter-x)*.2)",
                            paddingRight: "calc(var(--bs-gutter-x)*.2)",
                          }}
                          className="button btn-apo-bg circle"
                          disabled={!online}
                        >
                          {firstAccount?.mainButton}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <Button
            onClick={() => handleExpandClick()}
            id="chat-circle"
            className="btn btn-raised"
            style={{ display: "block" }}
          >
            <div id="chat-overlay"></div>
            <i className="fa fa-laptop" style={{ fontSize: "28px" }}></i>
          </Button>
        )}

        {/* <div id="chat-circle" className="btn btn-raised">
          <div id="chat-overlay"></div>
          <i className="fa fa-laptop" style={{ fontSize: "28px" }}></i>
        </div> */}
      </main>
    </div>
  );
}

export default IframePage;
